import { useAuthState, ContextHolder } from "@frontegg/react";
import Login from "../pages/auth/login";

export function useAuthCheck() {
  const { isAuthenticated, isLoading } = useAuthState();

  console.log("Auth loading:", isLoading);
  console.log("Authenticated:", isAuthenticated);

  const isContextReady = Boolean(ContextHolder.getContext());

  if (!isContextReady || isLoading) {
    return { isLoading: true, component: <div>Loading...</div> };
  }

  if (!isAuthenticated) {
    return { isLoading: false, component: <Login /> };
  }

  return { isLoading: false, component: null };
}
